import type { AlpineComponent } from 'alpinejs';
import type ReducedMotionStore from '../../../javascripts/stores/reduced-motion';

type NavigationData = {
  timeout: number | null;
  showNavigation: boolean;
  showSubNavigation: boolean;
  subNavigationIndex?: string;
  subNavigationDialogs: NodeListOf<HTMLDialogElement> | [];
  transitionDuration: number;
  getMinHeight: () => void;
  openNavigation: () => void;
  closeNavigation: () => void;
  openSubNavigation: (index: string) => void;
  closeSubNavigation: () => void;
};

const Navigation = (): AlpineComponent<NavigationData> => ({
  timeout: null,
  showNavigation: false,
  showSubNavigation: false,
  subNavigationIndex: undefined,
  subNavigationDialogs: [],
  get transitionDuration() {
    return (this.$store.reducedMotion as typeof ReducedMotionStore).reduceMotion
      ? 0
      : 300;
  },
  getMinHeight() {
    const mainNav = this.$refs.navigation.querySelector(
      '.navigation__main'
    ) as HTMLElement;

    this.$refs.navigation.style.setProperty(
      '--nav-min-height',
      `${mainNav?.offsetHeight}px`
    );
  },
  openNavigation() {
    if (this.timeout) clearTimeout(this.timeout);
    this.showNavigation = true;
    (this.$refs.navigation as HTMLDialogElement).showModal();
    this.getMinHeight();
  },
  closeNavigation() {
    this.showNavigation = false;
    this.showSubNavigation = false;
    this.subNavigationIndex = undefined;
    this.timeout = setTimeout(() => {
      this.subNavigationDialogs.forEach((el: HTMLDialogElement) => {
        el.close();
      });

      (this.$refs.navigation as HTMLDialogElement).close();
    }, this.transitionDuration);
  },
  openSubNavigation(index: string) {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.showSubNavigation) {
      this.subNavigationIndex = index;
      this.subNavigationDialogs.forEach((el: HTMLDialogElement) => {
        const dialogIndex = el.getAttribute('data-index');
        if (dialogIndex === index) {
          el.show();
        } else {
          el.close();
        }
      });
    } else {
      this.subNavigationIndex = index;
      this.showSubNavigation = true;
      this.subNavigationDialogs.forEach((el: HTMLDialogElement) => {
        const dialogIndex = el.getAttribute('data-index');
        if (dialogIndex === index) el.show();
      });
    }
  },
  closeSubNavigation() {
    this.showSubNavigation = false;
    this.timeout = setTimeout(() => {
      this.subNavigationDialogs.forEach((el: HTMLDialogElement) => {
        const dialogIndex = el.getAttribute('data-index');
        if (dialogIndex === this.subNavigationIndex) {
          el.close();
          this.subNavigationIndex = undefined;
        }
      });
    }, this.transitionDuration);
  },
  init() {
    this.subNavigationDialogs = document.querySelectorAll('[data-index]');

    this.$watch('showSubNavigation', (showSubNavigation: boolean) => {
      if (showSubNavigation) {
        const details = this.$root.querySelectorAll('details');
        if (details) {
          details.forEach((el: HTMLDetailsElement) => (el.open = false));
        }
      }
    });

    this.$watch('showNavigation', (showNavigation: boolean) => {
      document.body.style.overflow = showNavigation ? 'hidden' : 'visible';
    });
  }
});

export default Navigation;
